import { MOMENT_TIME } from "../../momenttime";
import { PAIPAN } from '../../data/core/paipan'
import { FORMAT } from "../core/format";
import { UTILS } from '../../utils'

var STRONG_DATA_MANAGER = {
    /**
     * 获取输入生日框的显示数据:根据日历输入返回的数据
     * @param {输入生日后的数据格式} data 
     * {year: '1988', month: '01', day: '29', hour: '22', minute: '00', isLunar: '', unknown: ''}
     */
    getSelectedBirthdayStringByData(data) {
        var result = [], tempdata = {}, str1 = '', str2 = '';
        var year = parseInt(data.year), month = parseInt(data.month), day = parseInt(data.day), hour = parseInt(data.hour), minute = data.minute ? parseInt(data.minute) : 0;
        var timeStr1 = data.unknownTime ? '' : '  ' + ((hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute));
        var timeStr2 = data.unknownTime ? '' : ' ' + FORMAT.getShiChenByNumber(hour);
        var isRun = data.run ? 1 : 0;

        if (data.isLunar) {
            // 农历时间
            tempdata = PAIPAN.Lunar2Solar(year, month, day, isRun);
            str1 = tempdata.y + '年' + (tempdata.m < 10 ? '0' + tempdata.m : tempdata.m) + '月' + (tempdata.d < 10 ? '0' + tempdata.d : tempdata.d) + '日' + timeStr1;
            str2 = FORMAT.getChineseWordByNumber('year', year) + (tempdata.r == 1 || isRun == 1 ? '闰' : '') + FORMAT.getChineseWordByNumber('month', month) + FORMAT.getChineseWordByNumber('day', day) + timeStr2;
        } else {
            // 公历时间
            tempdata = PAIPAN.Solar2Lunar(year, month, day);
            str1 = year + '年' + (month < 10 ? '0' + month : month) + '月' + (day < 10 ? '0' + day : day) + '日' + timeStr1;
            str2 = FORMAT.getChineseWordByNumber('year', tempdata.y) + (tempdata.r == 1 || isRun == 1 ? '闰' : '') + FORMAT.getChineseWordByNumber('month', tempdata.m) + FORMAT.getChineseWordByNumber('day', tempdata.d) + timeStr2;
        }
        result.push(str1);
        result.push(str2);
        console.log('getSelectedBirthdayStringByData----', result);
        return str1;
    },
    // 获取排盘参数Birthday
    getPaiPanParamsBirthday(params) {
        var y, m, d, h, mi, r;
        h = params.hour ? parseInt(params.hour) : 0;
        mi = params.minute ? parseInt(params.minute) : 0;
        y = parseInt(params.year);
        m = parseInt(params.month);
        d = parseInt(params.day);
        r = params.run ? 1 : 0;

        // 农历要转换成公历
        if (params.isLunar) {
            var temp = PAIPAN.Lunar2Solar(y, m, d, r)
            y = temp.y;
            m = temp.m;
            d = temp.d;
        }
        // 拼凑字符串
        var dateStr = UTILS.formatYearNum(y) + '-';
        dateStr = dateStr + ((m > 0 && m < 10) ? ('0' + m) : m) + '-';
        dateStr = dateStr + ((d > 0 && d < 10) ? ('0' + d) : d) + ' ';
        if (!params.unknownTime) {
            dateStr = dateStr + ((h >= 0 && h < 10) ? ('0' + h) : h) + ':';
            dateStr = dateStr + ((mi >= 0 && mi < 10) ? ('0' + mi) : mi) + ':00';
        }else{
            dateStr = dateStr + '00:00:00'
        }
        // var time = moment(dateStr).unix();
        var time = MOMENT_TIME.getUnixTimeByTimeStr(dateStr);

        console.log('起盘生日为::::', dateStr, time);
        return time;
    },
    /**
     * 根据服务器返回的测评报告数据来获取前端所需数据
     * @param {测评报告数据} reportData 
     */
    getReportAIDataByData(reportData) {
        var resultData = {};
        for(var keys in reportData) {
            resultData[keys] = reportData[keys];
        }
        return resultData;
    },
    /**
     * 根据数据返回UI数据
     * @param {测评报告数据} data 
     */
    getReportBaziInfoByData(data) {
        let retArr = [];
        let timeStr = data.realDateStr ? data.realDateStr : data.realDate ? data.realDate : data.birthdayDate ? data.birthdayDate : '';
        let timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(MOMENT_TIME.getUnixTimeByTimeStr(timeStr)*1000);
        let lunarTime = PAIPAN.Solar2Lunar(timeArr[0], timeArr[1], timeArr[2]);
        let lTimeArr = [lunarTime.y, lunarTime.m, lunarTime.d];
        let typeArr = ['year', 'month', 'day'], titleArr = ['年', '月', '日', '时', '分'];
        data.eightWordArr = data.eightWordArr && data.eightWordArr.length > 0 ? data.eightWordArr : FORMAT.getEightWordArrByData(data.unknown, data);
        for(let i = 0; i < 4; i++) {
            retArr.push({
                title: titleArr[i]+'柱',
                solar: i == 0 ? timeArr[i]+titleArr[i] : i < 3 ? UTILS.getTimeStrByInt(timeArr[i])+titleArr[i] : UTILS.getTimeStrByInt(timeArr[i])+titleArr[i]+UTILS.getTimeStrByInt(timeArr[i+1])+titleArr[i+1],
                lunar: i < 3 ? i == 1 && lunarTime.r ? '闰'+FORMAT.getChineseWordByNumber(typeArr[i], lTimeArr[i]) : FORMAT.getChineseWordByNumber(typeArr[i], lTimeArr[i]) : FORMAT.getShiChenByNumber(timeArr[i]),
                tg: data.eightWordArr[i][0],
                dz: data.eightWordArr[i][1]
            });
        };

        console.log('getReportBaziInfoByData------', timeArr, lunarTime, retArr);
        return retArr;
    },
    /**
     * 根据数据返回UI数据
     * @param {测评报告数据} data 
     */
    getReportStrongInfoByData(data) {
        let retObj = Object.assign({
            gold: {text: '金', value: Math.round(data.wx['金']) ? Math.round(data.wx['金']) : 0, textEn: 'gold'},
            wood: {text: '木', value: Math.round(data.wx['木']) ? Math.round(data.wx['木']) : 0, textEn: 'wood'},
            water: {text: '水', value: Math.round(data.wx['水']) ? Math.round(data.wx['水']) : 0, textEn: 'water'},
            fire: {text: '火', value: Math.round(data.wx['火']) ? Math.round(data.wx['火']) : 0, textEn: 'fire'},
            soil: {text: '土', value: Math.round(data.wx['土']) ? Math.round(data.wx['土']) : 0, textEn: 'soil'},
        }) ;
        retObj = Object.assign({
            goodWx: data.goodWx.map(el => Object.assign({
                wxText: el, wxEn: FORMAT.getWuXingEnByText(el)
            })),
            badWx: data.badWx.map(el => Object.assign({
                wxText: el, wxEn: FORMAT.getWuXingEnByText(el)
            })),
            strong: data.strong,
            goodColour: data.goodColour,
            badColour: data.badColour,
            goodAni: data.animals.good.map(el => el[1]+'('+el[0]+')'),
            badAni: data.animals.bad.map(el => el[0]+el[1])
        }, retObj);
        console.log('getReportStrongInfoByData---', data, retObj);
        return retObj;
    }
}

export {
    STRONG_DATA_MANAGER
}